import logout from '@/api/auth/logout';
import { navigationNamespace } from '@/i18n';
import { getTranslated } from '@/i18n/get-translated';
import {
	BoxIcon,
	CardIcon,
	CargoIcon,
	CompanyIcon,
	CubesIcon,
	DocumentsIcon,
	ExitIcon,
	FishIcon,
	FishPlusIcon,
	FishWithBubbleIcon,
	HomeIcon,
	InformationEmptyIcon,
	OpenLockIcon,
	SkyscraperIcon,
	SnowflakeIcon,
} from '@/UI/icons';

import { MobileMenuItem } from './MobileMenu.types';

const lkIconSize = 16;

const t = getTranslated(navigationNamespace);

export const getWarehouseItems = (): MobileMenuItem[] => [
	{
		link: '/',
		icon: <HomeIcon />,
		text: t('desktop'),
	},
	{
		link: '/depositor-company',
		icon: <SnowflakeIcon />,
		text: t('find-warehouse'),
	},
	{
		link: '/storage',
		icon: <BoxIcon />,
		text: t('for-storage'),
	},
	{
		link: '/about-us',
		icon: <InformationEmptyIcon />,
		text: t('about-us'),
	},
];

export const getWarehouseLkItems = (): MobileMenuItem[] => [
	{
		link: '/storage-account',
		icon: <CubesIcon size={lkIconSize} />,
		text: t('desktop'),
	},
	{
		link: '/storage-account/applications',
		icon: <DocumentsIcon size={lkIconSize} />,
		text: t('applications'),
	},
	{
		link: '/storage-account/suppliers',
		icon: <CargoIcon size={lkIconSize} />,
		text: t('suppliers'),
	},
	{
		link: '/storage-account/fish-products',
		icon: <FishIcon size={lkIconSize} />,
		text: t('fishproducts'),
	},
	{
		link: '/storage-account/additional-services',
		icon: <CardIcon size={lkIconSize} />,
		text: t('additional-services'),
	},
	{
		link: '/storage-account/refrigerators',
		icon: <CardIcon size={lkIconSize} />,
		text: t('refrigerators'),
	},
	{
		link: '/storage-account/settings',
		icon: <CompanyIcon size={lkIconSize} />,
		text: t('profile'),
	},
	{
		icon: <ExitIcon size={lkIconSize} />,
		text: t('logout'),
		onClick: async () => {
			await logout();
		},
	},
];

export const getUnauthorizedItems = (): MobileMenuItem[] => [
	{
		link: '/login',
		background: '#06519E',
		icon: <OpenLockIcon />,
		text: t('sign-in'),
	},
	{
		link: '/',
		icon: <HomeIcon />,
		text: t('home'),
	},
	{
		link: '/buy-fish',
		icon: <FishPlusIcon />,
		text: t('buy-fish'),
	},
	{
		link: '/sell-fish',
		icon: <FishWithBubbleIcon />,
		text: t('sell-fish'),
	},
	{
		link: '/depositor-company',
		icon: <SnowflakeIcon />,
		text: t('for-depositor-company'),
	},
	{
		link: '/storage',
		icon: <BoxIcon />,
		text: t('for-storage'),
	},
	{
		link: '/about-us',
		icon: <InformationEmptyIcon />,
		text: t('about-us'),
	},
];

export const getFishCompanyItems = (): MobileMenuItem[] => [
	{
		link: '/',
		icon: <HomeIcon />,
		text: t('home'),
	},
	{
		link: '/buy-fish',
		icon: <FishPlusIcon />,
		text: t('buy-fish'),
	},
	{
		link: '/sell-fish',
		icon: <FishWithBubbleIcon />,
		text: t('sell-fish'),
	},
	{
		link: '/depositor-company',
		icon: <SnowflakeIcon />,
		text: t('for-depositor-company'),
	},
	{
		link: '/about-us',
		icon: <InformationEmptyIcon />,
		text: t('about-us'),
	},
];

export const getFishCompanyLkItems = (digital_office: string): MobileMenuItem[] => [
	{
		link: '/personal-account',
		icon: <CubesIcon size={lkIconSize} />,
		text: t('desktop'),
	},
	{
		link: '/personal-account/warehouses',
		icon: <CargoIcon height={14} width={lkIconSize} />,
		text: t('warehouses'),
	},
	{
		link: '/personal-account/applications',
		icon: <DocumentsIcon size={lkIconSize} />,
		text: t('applications'),
	},
	{
		link: '/personal-account/fish-products',
		icon: <FishIcon height={12} width={lkIconSize} />,
		text: t('fishproducts'),
	},
	{
		link: '/personal-account/payments',
		icon: <CardIcon height={11.6} width={lkIconSize} />,
		text: t('payment'),
	},
	{
		link: '/personal-account/settings',
		icon: <CompanyIcon size={lkIconSize} />,
		text: t('profile'),
	},
	{
		link: `${window.location.origin}/office/${digital_office}`,
		icon: <SkyscraperIcon size={lkIconSize} />,
		text: t('digital-office'),
	},
	{
		icon: <ExitIcon size={lkIconSize} />,
		text: t('logout'),
		onClick: async () => {
			await logout();
		},
	},
];
